import styled from 'styled-components';

/** The Strands WebGL canvas — fills the morph slot; `display:block` kills the
 *  inline-canvas baseline gap. Sized in device pixels by the component. */
export const Canvas = styled.canvas`
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;
